export default __webpack_public_path__ + "static/media/GN.050b3ad6.svg";